import React, { useState } from "react";
import { ThemeProvider } from "next-themes";
import { Toaster } from "sonner";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Header from "./components/Header";
import TagGenerator from "./components/TagGenerator";
import Footer from "./components/Footer";
import { About, Terms, Policy, Disclaimer, CookiePolicy } from "./components/LegalPages";
import Contact from "./components/Contact";
import BlogList from "./components/BlogList";
import BlogPost from "./components/BlogPost";
import AdminDashboard from "./components/AdminDashboard";
import ScrollToTop from "./components/ScrollToTop";
import CookieConsent from "./components/CookieConsent";
import MonetagScript from "./components/MonetagScript";
import DefaultSEO from "./components/DefaultSEO";
import "@/App.css";

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
        <Router>
          <ScrollToTop />
          <DefaultSEO />
          <MonetagScript />
          <div className="min-h-screen bg-background text-foreground transition-colors duration-300 flex flex-col">
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<TagGenerator />} />
                <Route path="/about" element={<About />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/policy" element={<Policy />} />
                <Route path="/cookie-policy" element={<CookiePolicy />} />
                <Route path="/disclaimer" element={<Disclaimer />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/blog" element={<BlogList />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/admin/edit/:slug" element={<AdminDashboard />} />
                <Route path="*" element={<TagGenerator />} />
              </Routes>
            </main>
            <Footer />
            <Toaster position="bottom-right" />
            <CookieConsent />
          </div>
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
